export enum DeliveryIndicatorStatus {
  IN_PREPARATION = 1,
  SHIPPED = 2,
}
